/** Reducer for List certificate request */

import { fromJS } from 'immutable';
import { SET_LIST_SUBJECT } from '../actions/subjectConst';

export const initialState = {
  listSubject: []
};

const initialImmutableState = fromJS(initialState);

const subject = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_LIST_SUBJECT:
      state = initialState;
      return state.listSubject.concat(action.subject);
    default:
      return state;
  }
};

export default subject;
